module.exports = __webpack_public_path__ + "img/comparison-brand-brand.4e3a951a.png";